import { render, staticRenderFns } from "./actionmodal.vue?vue&type=template&id=99fa1462&scoped=true&"
import script from "./actionmodal.vue?vue&type=script&lang=js&"
export * from "./actionmodal.vue?vue&type=script&lang=js&"
import style0 from "./actionmodal.vue?vue&type=style&index=0&id=99fa1462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fa1462",
  null
  
)

export default component.exports